var _rect, _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _g3, _path0, _path1, _path10, _path11, _path12, _path13, _g4, _path14, _rect2, _path15, _path16, _g5, _path17, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path18, _path19, _g6, _path20, _rect3, _path21, _path22, _g7, _path23, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path24, _path25, _g8, _path26, _rect4, _path27, _path28, _g9, _path29, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _rect5, _rect6, _rect7, _g0, _rect8, _rect9, _rect0, _g1, _rect1, _path30, _path31, _g10, _path32, _path33, _path34, _path35, _path36, _path37, _g11, _path38, _rect10, _rect11, _rect12, _g12, _rect13, _path39, _path40, _g13, _path41, _path42, _path43, _path44, _path45, _g14, _path46, _rect14, _rect15, _path47, _path48, _g15, _path49, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _path50, _path51, _path52, _path53, _path54, _g16, _path55, _path56, _path57, _path58, _path59, _path60, _g17, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _g18, _path69, _path70, _path71, _g19, _path72, _path73, _path74, _g20, _path75, _ellipse11, _ellipse12, _path76, _path77, _ellipse13, _ellipse14, _path78, _path79, _path80, _path81, _path82, _g21, _path83, _path84, _path85, _path86, _path87, _path88, _ellipse15, _path89, _path90, _g22, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _g23, _path104, _path105, _path106, _g24, _path107, _path108, _g25, _path109, _path110, _path111, _g26, _path112, _path113, _path114, _path115, _path116, _g27, _path117, _path118, _path119, _g28, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _ellipse16, _path130, _path131, _path132, _path133, _path134, _ellipse17, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _g29, _path146, _rect23, _rect24, _g30, _rect25, _rect26, _rect27, _path147, _path148, _g31, _path149, _path150, _path151, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandinImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 731,
    height: 548,
    viewBox: "0 0 731 548",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 731,
    height: 548
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 730.667,
    height: 548,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1502_32914)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M563.364 132.796C567.05 134.799 569.301 138.701 569.188 142.894C567.226 208.309 537.187 274.106 477.936 316.361C474.024 319.156 468.767 319.156 464.855 316.361C405.522 274.048 375.483 208.129 373.594 142.626C373.485 138.56 375.599 134.757 379.111 132.705C404.012 118.115 432.987 103.385 464.207 86.6877C468.698 84.2821 474.097 84.295 478.577 86.722C495.947 96.1417 540.484 120.303 563.364 132.796Z",
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M563.364 137.136C567.05 139.139 569.301 143.041 569.188 147.234C567.226 212.649 537.187 278.446 477.936 320.701C474.024 323.496 468.767 323.496 464.855 320.701C405.522 278.388 375.483 212.469 373.594 146.966C373.485 142.9 375.599 139.097 379.111 137.045C404.012 122.454 432.987 107.725 464.207 91.0275C468.698 88.622 474.097 88.6348 478.577 91.0618C495.947 100.482 540.484 124.642 563.364 137.136Z",
    fill: "#E43334"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 373,
    y: 89,
    width: 197,
    height: 234
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.364 137.134C567.05 139.137 569.301 143.039 569.188 147.232C567.226 212.647 537.187 278.444 477.936 320.699C474.024 323.494 468.767 323.494 464.855 320.699C405.522 278.386 375.483 212.467 373.594 146.964C373.485 142.898 375.599 139.095 379.111 137.043C404.012 122.452 432.987 107.723 464.207 91.0256C468.698 88.62 474.097 88.6329 478.577 91.0599C495.947 100.48 540.484 124.641 563.364 137.134Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.961 95.0684C479.361 95.7693 562.579 135.519 569.188 147.234C575.798 158.949 565.132 123.355 565.132 123.355L516.691 99.7736",
    fill: "url(#paint0_linear_1502_32914)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.364 137.136C567.05 139.139 569.301 143.041 569.188 147.234C567.226 212.649 537.187 278.446 477.936 320.701C474.024 323.496 468.767 323.496 464.855 320.701C405.522 278.388 375.483 212.469 373.594 146.966C373.485 142.9 375.599 139.097 379.111 137.045C404.012 122.454 432.987 107.725 464.207 91.0275C468.698 88.622 474.097 88.6348 478.577 91.0618C495.947 100.482 540.484 124.642 563.364 137.136Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M563.364 137.136C567.05 139.139 569.301 143.041 569.188 147.234C567.226 212.649 537.187 278.446 477.936 320.701C474.024 323.496 468.767 323.496 464.855 320.701C405.522 278.388 375.483 212.469 373.594 146.966C373.485 142.9 375.599 139.097 379.111 137.045C404.012 122.454 432.987 107.725 464.207 91.0275C468.698 88.622 474.097 88.6348 478.577 91.0618C495.947 100.482 540.484 124.642 563.364 137.136Z",
    fill: "#E43334"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 373,
    y: 89,
    width: 197,
    height: 234
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.364 137.134C567.05 139.137 569.301 143.039 569.188 147.232C567.226 212.647 537.187 278.444 477.936 320.699C474.024 323.494 468.767 323.494 464.855 320.699C405.522 278.386 375.483 212.467 373.594 146.964C373.485 142.898 375.599 139.095 379.111 137.043C404.012 122.452 432.987 107.723 464.207 91.0256C468.698 88.62 474.097 88.6329 478.577 91.0599C495.947 100.48 540.484 124.641 563.364 137.134Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.467 216.322C453.128 319.1 495.715 306.561 495.715 306.561C495.715 306.561 495.804 334.693 489.138 339.365C482.472 344.037 433.142 341.367 431.143 340.033C429.143 338.698 398.64 271.292 398.64 271.292L384.467 216.322Z",
    fill: "#C11F27"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.364 137.136C567.05 139.139 569.301 143.041 569.188 147.234C567.226 212.649 537.187 278.446 477.936 320.701C474.024 323.496 468.767 323.496 464.855 320.701C405.522 278.388 375.483 212.469 373.594 146.966C373.485 142.9 375.599 139.097 379.111 137.045C404.012 122.454 432.987 107.725 464.207 91.0275C468.698 88.622 474.097 88.6348 478.577 91.0618C495.947 100.482 540.484 124.642 563.364 137.136Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M539.806 155.752C542.532 157.186 544.211 160.041 544.139 163.121C542.679 210.856 520.334 258.87 476.259 289.706C473.336 291.745 469.451 291.745 466.528 289.706C422.393 258.828 400.048 210.725 398.643 162.925C398.572 159.94 400.149 157.157 402.747 155.685C421.27 145.038 442.823 134.29 466.046 122.105C469.396 120.349 473.395 120.359 476.736 122.13C489.657 129.004 522.786 146.635 539.806 155.752Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 398,
    y: 120,
    width: 147,
    height: 172
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539.807 155.754C542.533 157.188 544.212 160.043 544.14 163.123C542.68 210.858 520.335 258.872 476.26 289.708C473.337 291.747 469.452 291.747 466.529 289.708C422.394 258.83 400.049 210.727 398.644 162.927C398.572 159.942 400.15 157.159 402.748 155.687C421.271 145.04 442.824 134.292 466.047 122.107C469.397 120.351 473.396 120.361 476.737 122.132C489.658 129.006 522.787 146.637 539.807 155.754Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.584 114.459C513.581 137.15 551.356 165.625 535.357 218.571C519.359 271.518 560.244 164.736 560.244 164.736L546.467 150.498",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.584 114.459C513.581 137.15 551.356 165.625 535.357 218.571C519.359 271.518 560.244 164.736 560.244 164.736L546.468 150.498",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.408 100.58L471.392 115.707C471.392 115.707 478.075 154.861 471.392 291.237C469.588 328.06 534.737 325.49 534.737 325.49L559.402 153.304L523.208 102.949",
    fill: "#D6DCF2"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539.806 155.752C542.532 157.186 544.211 160.041 544.139 163.121C542.679 210.856 520.334 258.87 476.259 289.706C473.336 291.745 469.451 291.745 466.528 289.706C422.393 258.828 400.048 210.725 398.643 162.925C398.572 159.94 400.149 157.157 402.747 155.685C421.27 145.038 442.823 134.29 466.046 122.105C469.396 120.349 473.395 120.359 476.736 122.13C489.657 129.004 522.786 146.635 539.806 155.752Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M504.739 185.286H485.175V165.7C485.176 164.571 484.728 163.488 483.93 162.69C483.133 161.891 482.05 161.442 480.922 161.441H465.612C463.261 161.443 461.357 163.349 461.358 165.7V185.286H441.795C439.444 185.288 437.54 187.194 437.541 189.545V204.872C437.54 207.223 439.444 209.129 441.795 209.131H461.358V228.717C461.357 231.068 463.261 232.974 465.612 232.976H480.922C483.272 232.974 485.177 231.068 485.175 228.717V209.131H504.739C507.089 209.13 508.994 207.223 508.992 204.872V189.545C508.994 187.194 507.089 185.288 504.739 185.286Z",
    fill: "#E43334",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M488.743 146.053C494.098 147.586 498.796 150.848 502.104 155.33",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M452.722 250.055L457.747 254.247",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.544 167.975H160.424V289.964C160.424 297.663 154.183 303.904 146.484 303.904C138.786 303.904 132.545 297.663 132.545 289.964V167.975H132.544Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 167,
    width: 29,
    height: 137
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.544 167.975H160.424V289.964C160.424 297.663 154.183 303.904 146.484 303.904C138.786 303.904 132.545 297.663 132.545 289.964V167.975H132.544Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.195 203.141C131.232 178.393 147.825 172.365 154.703 172.365C161.582 172.365 136.206 170.17 136.206 170.17L125.581 172.365L126.485 181.278",
    fill: "#D6DCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.774 251.135C160.424 289.948 156.915 303.942 146.485 306.658C136.055 309.374 168.607 307.262 168.607 307.262L165.894 263.809L163.774 251.135Z",
    fill: "#D6DCF2"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.544 167.975H160.424V289.964C160.424 297.663 154.183 303.904 146.484 303.904V303.904C138.786 303.904 132.545 297.663 132.545 289.964V167.975H132.544Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 129.195,
    y: 167.975,
    width: 34.5789,
    height: 4.38979,
    rx: 2.19363,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M146.241 301.73H146.729C150.031 301.728 153.198 300.414 155.532 298.077C157.866 295.741 159.177 292.572 159.175 289.269V216.161C146.88 219.84 143.515 206.709 133.794 209.112V289.269C133.793 292.572 135.103 295.741 137.437 298.077C139.771 300.414 142.938 301.728 146.241 301.73Z",
    fill: "#1AB995"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 208,
    width: 27,
    height: 94
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.24 301.73H146.728C150.031 301.728 153.198 300.414 155.532 298.077C157.866 295.741 159.176 292.572 159.174 289.269V216.161C146.88 219.84 143.514 206.709 133.794 209.112V289.269C133.792 292.572 135.102 295.741 137.436 298.077C139.771 300.414 142.938 301.728 146.24 301.73Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.195 290.093C132.545 277.481 132.385 301.729 160.424 301.729C188.463 301.729 157.703 310.396 157.703 310.396L124.612 304.251",
    fill: "#0FA379"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.241 301.73H146.729C150.031 301.728 153.198 300.414 155.532 298.077C157.866 295.741 159.177 292.572 159.175 289.269V216.161C146.88 219.84 143.515 206.709 133.794 209.112V289.269C133.793 292.572 135.103 295.741 137.437 298.077C139.771 300.414 142.938 301.728 146.241 301.73V301.73Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.939,
    cy: 239.067,
    rx: 1.07717,
    ry: 1.07841,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.214,
    cy: 238.303,
    rx: 1.48855,
    ry: 1.49029,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.484,
    cy: 282.535,
    rx: 3.94885,
    ry: 3.95342,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.591,
    cy: 245.224,
    rx: 0.92064,
    ry: 0.921718,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M174.768 167.975H202.647V289.964C202.647 297.663 196.406 303.904 188.707 303.904C181.009 303.904 174.768 297.663 174.768 289.964V167.975H174.768Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 167,
    width: 29,
    height: 137
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.768 167.975H202.647V289.964C202.647 297.663 196.406 303.904 188.707 303.904C181.009 303.904 174.768 297.663 174.768 289.964V167.975H174.768Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.418 208.817C173.455 184.069 190.047 172.365 196.925 172.365C203.804 172.365 178.428 170.17 178.428 170.17L167.803 172.365L168.707 181.278",
    fill: "#D6DCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.996 251.135C202.647 289.948 199.137 303.942 188.707 306.658C178.277 309.374 210.829 307.262 210.829 307.262L208.116 263.809L205.996 251.135Z",
    fill: "#D6DCF2"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.768 167.975H202.647V289.964C202.647 297.663 196.406 303.904 188.707 303.904V303.904C181.009 303.904 174.768 297.663 174.768 289.964V167.975H174.768Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 171.418,
    y: 167.975,
    width: 34.5789,
    height: 4.38979,
    rx: 2.19363,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M188.464 301.731H188.952C192.255 301.729 195.421 300.416 197.756 298.079C200.09 295.742 201.4 292.574 201.398 289.271V235.286C189.103 238.965 185.738 225.834 176.018 228.237V289.271C176.016 292.574 177.326 295.742 179.66 298.079C181.994 300.416 185.161 301.73 188.464 301.731Z",
    fill: "#E43334"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 227,
    width: 26,
    height: 75
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.464 301.729H188.952C192.255 301.728 195.421 300.414 197.756 298.077C200.09 295.74 201.4 292.572 201.398 289.269V235.284C189.103 238.963 185.738 225.832 176.018 228.235V289.269C176.016 292.572 177.326 295.74 179.66 298.077C181.994 300.414 185.161 301.728 188.464 301.729Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.418 291.811C176.017 280.25 177.461 302.702 196.926 301.73C216.39 300.758 183.161 311.72 183.161 311.72L172.199 303.904",
    fill: "#C11F27"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.464 301.731H188.952C192.255 301.729 195.421 300.416 197.756 298.079C200.09 295.742 201.4 292.574 201.398 289.271V235.286C189.103 238.965 185.738 225.834 176.018 228.237V289.271C176.016 292.574 177.326 295.742 179.66 298.079C181.994 300.416 185.161 301.73 188.464 301.731V301.731Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.162,
    cy: 239.067,
    rx: 1.07717,
    ry: 1.07841,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.438,
    cy: 238.303,
    rx: 1.48855,
    ry: 1.49029,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 188.707,
    cy: 282.535,
    rx: 3.94885,
    ry: 3.95342,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.814,
    cy: 245.224,
    rx: 0.92064,
    ry: 0.921718,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M214.453 167.975H242.333V289.964C242.333 297.663 236.092 303.904 228.393 303.904C220.694 303.904 214.453 297.663 214.453 289.964V167.975H214.453Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 214,
    y: 167,
    width: 29,
    height: 137
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.454 167.975H242.333V289.964C242.333 297.663 236.092 303.904 228.393 303.904C220.695 303.904 214.454 297.663 214.454 289.964V167.975H214.454Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.104 199.347C213.141 174.599 229.733 172.365 236.612 172.365C243.49 172.365 218.114 170.17 218.114 170.17L207.489 172.365L208.393 181.278",
    fill: "#D6DCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.683 251.135C242.333 289.948 238.823 303.942 228.393 306.658C217.963 309.374 250.516 307.262 250.516 307.262L247.803 263.809L245.683 251.135Z",
    fill: "#D6DCF2"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.453 167.975H242.333V289.964C242.333 297.663 236.092 303.904 228.393 303.904V303.904C220.694 303.904 214.453 297.663 214.453 289.964V167.975H214.453Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 211.104,
    y: 167.975,
    width: 34.5789,
    height: 4.38979,
    rx: 2.19363,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M228.15 301.728H228.637C231.94 301.727 235.107 300.413 237.441 298.076C239.775 295.739 241.085 292.571 241.083 289.268V227.524C228.789 231.203 225.423 218.073 215.703 220.476V289.268C215.701 292.571 217.011 295.739 219.346 298.076C221.68 300.413 224.847 301.727 228.15 301.728Z",
    fill: "#FDD504"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 215,
    y: 220,
    width: 27,
    height: 82
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.15 301.73H228.637C231.94 301.728 235.107 300.415 237.441 298.078C239.775 295.741 241.085 292.573 241.083 289.27V227.526C228.789 231.205 225.423 218.074 215.703 220.478V289.27C215.701 292.573 217.011 295.741 219.346 298.078C221.68 300.415 224.847 301.729 228.15 301.73Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.604 291.81C213.932 281.07 228.536 306.91 242.333 299.527C256.13 292.144 235.123 311.719 235.123 311.719L205.997 306.91",
    fill: "#FCB006"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.15 301.728H228.637C231.94 301.727 235.107 300.413 237.441 298.076C239.775 295.739 241.085 292.571 241.083 289.268V227.524C228.789 231.203 225.423 218.073 215.703 220.476V289.268C215.701 292.571 217.011 295.739 219.346 298.076C221.68 300.413 224.847 301.727 228.15 301.728Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.847,
    cy: 239.067,
    rx: 1.07717,
    ry: 1.07841,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.122,
    cy: 238.303,
    rx: 1.48855,
    ry: 1.49029,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.393,
    cy: 282.535,
    rx: 3.94885,
    ry: 3.95342,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.499,
    cy: 245.224,
    rx: 0.92064,
    ry: 0.921718,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 93.1899,
    y: 206.205,
    width: 188.497,
    height: 6.61195,
    rx: 3.30406,
    fill: "#FDD504",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 107.362,
    y: 197.389,
    width: 6.32911,
    height: 119.015,
    rx: 3.16455,
    fill: "#FCB006"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 197,
    width: 7,
    height: 120
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 107.362,
    y: 197.389,
    width: 6.32911,
    height: 119.015,
    rx: 3.16455,
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.9295 278.582C103.662 305.525 137.61 302.107 140.938 317.297C144.267 332.488 117.516 335.978 115.605 337.251C113.694 338.525 103.726 321.418 101.274 317.297C98.8215 313.177 91.6665 291.895 91.6665 291.895",
    fill: "#FDD504"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 107.362,
    y: 197.389,
    width: 6.32911,
    height: 119.015,
    rx: 3.16455,
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 261.187,
    y: 197.389,
    width: 6.32911,
    height: 119.015,
    rx: 3.16455,
    fill: "#FCB006"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 261,
    y: 197,
    width: 7,
    height: 120
  }, _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 261.187,
    y: 197.389,
    width: 6.32911,
    height: 119.015,
    rx: 3.16455,
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.07 225.656C245.682 251.135 237.898 246.144 257.006 264.835C276.115 283.526 288.535 289.265 270.382 295.482C252.229 301.7 293.312 301.73 293.312 301.73L286.146 237.988L281.688 229.961",
    fill: "#FDD504"
  }))), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 261.187,
    y: 197.389,
    width: 6.32911,
    height: 119.015,
    rx: 3.16455,
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M104.341 311.721H270.536C276.695 311.721 281.687 316.713 281.687 322.872V322.878H93.1899V322.872C93.1899 319.914 94.3648 317.078 96.4561 314.987C98.5473 312.896 101.384 311.721 104.341 311.721V311.721Z",
    fill: "#FCB006"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 311,
    width: 189,
    height: 12
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.341 311.721H270.536C276.694 311.721 281.687 316.713 281.687 322.872V322.878H93.1895V322.872C93.1895 319.914 94.3643 317.078 96.4556 314.987C98.5468 312.896 101.383 311.721 104.341 311.721V311.721Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.2695 322.877C131.488 322.877 281.966 314.852 288.773 318.798C295.58 322.744 272.65 331.833 271.217 332.49C269.784 333.146 85.2695 322.877 85.2695 322.877Z",
    fill: "#FDD504"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.341 311.721H270.536C276.695 311.721 281.687 316.713 281.687 322.872V322.878H93.1899V322.872C93.1899 319.914 94.3648 317.078 96.4561 314.987C98.5473 312.896 101.384 311.721 104.341 311.721V311.721Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M227.498 262.432L225.648 266.12",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M141.386 194.098C142.805 191.783 144.978 190.027 147.54 189.127",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M157.472 319.068L159.349 316.633",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.677 169.656H334.023C341.895 169.643 348.271 163.26 348.275 155.388V131.132C348.271 123.26 341.895 116.877 334.023 116.863H288.677C280.805 116.877 274.429 123.26 274.425 131.132V155.388C274.429 163.26 280.805 169.643 288.677 169.656ZM287.908 130.365C289.234 129.037 291.033 128.291 292.909 128.29L329.791 128.29C331.667 128.291 333.466 129.037 334.792 130.365C336.118 131.692 336.863 133.492 336.861 135.368V155.387C336.862 156.14 336.563 156.863 336.031 157.396C335.499 157.929 334.776 158.228 334.023 158.229H288.677C287.924 158.228 287.202 157.929 286.669 157.396C286.137 156.863 285.838 156.14 285.839 155.387V135.368C285.838 133.492 286.582 131.692 287.908 130.365Z",
    fill: "#E43334"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 274,
    y: 116,
    width: 75,
    height: 54
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.023 169.656H288.677C280.805 169.643 274.429 163.26 274.425 155.388V131.132C274.429 123.26 280.805 116.877 288.677 116.863H334.023C341.895 116.877 348.271 123.26 348.275 131.132V155.388C348.271 163.26 341.895 169.643 334.023 169.656ZM292.909 128.29C291.033 128.291 289.234 129.037 287.908 130.365C286.582 131.692 285.838 133.492 285.839 135.368V155.387C285.838 156.14 286.137 156.863 286.669 157.396C287.202 157.929 287.924 158.228 288.677 158.229H334.023C334.776 158.228 335.499 157.929 336.031 157.396C336.563 156.863 336.862 156.14 336.861 155.387V135.368C336.863 133.492 336.118 131.692 334.792 130.365C333.466 129.037 331.667 128.291 329.791 128.29L292.909 128.29Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.311 125.84C271.402 141.8 340.675 138.25 352.675 142.892C364.675 147.534 344.766 160.093 343.402 160.64C342.039 161.186 263.493 155.779 263.493 155.779L258.583 137.977",
    fill: "#C11F27"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M288.677 169.656L288.675 171.118H288.677V169.656ZM274.425 155.388H272.964L272.964 155.389L274.425 155.388ZM274.425 131.132L272.964 131.131V131.132H274.425ZM288.677 116.863V115.402L288.675 115.402L288.677 116.863ZM334.023 116.863L334.026 115.402H334.023V116.863ZM348.275 131.132H349.737V131.131L348.275 131.132ZM348.275 155.388L349.737 155.389V155.388H348.275ZM292.909 128.29L292.909 126.828H292.908L292.909 128.29ZM285.839 135.368H287.3L287.3 135.367L285.839 135.368ZM285.839 155.387L287.3 155.388V155.387H285.839ZM288.677 158.229L288.676 159.69H288.677V158.229ZM334.023 158.229V159.69H334.024L334.023 158.229ZM336.861 155.387H335.4V155.388L336.861 155.387ZM336.861 135.368L335.4 135.367V135.368H336.861ZM329.791 128.29L329.792 126.828H329.791L329.791 128.29ZM334.023 168.195H288.677V171.118H334.023V168.195ZM288.68 168.195C281.613 168.183 275.89 162.453 275.887 155.387L272.964 155.389C272.969 164.067 279.997 171.103 288.675 171.118L288.68 168.195ZM275.887 155.388V131.132H272.964V155.388H275.887ZM275.887 131.133C275.89 124.066 281.613 118.337 288.68 118.325L288.675 115.402C279.997 115.417 272.969 122.453 272.964 131.131L275.887 131.133ZM288.677 118.325H334.023V115.402H288.677V118.325ZM334.021 118.325C341.087 118.337 346.81 124.066 346.814 131.133L349.737 131.131C349.732 122.453 342.704 115.417 334.026 115.402L334.021 118.325ZM346.814 131.132V155.388H349.737V131.132H346.814ZM346.814 155.387C346.81 162.453 341.087 168.183 334.021 168.195L334.026 171.118C342.704 171.103 349.732 164.067 349.737 155.389L346.814 155.387ZM292.908 126.828C290.645 126.83 288.474 127.73 286.874 129.332L288.942 131.397C289.994 130.344 291.421 129.752 292.91 129.751L292.908 126.828ZM286.874 129.332C285.274 130.934 284.376 133.105 284.377 135.369L287.3 135.367C287.299 133.879 287.89 132.451 288.942 131.397L286.874 129.332ZM284.377 135.368V155.387H287.3V135.368H284.377ZM284.377 155.386C284.377 156.527 284.829 157.621 285.636 158.429L287.703 156.363C287.445 156.104 287.3 155.754 287.3 155.388L284.377 155.386ZM285.636 158.429C286.442 159.236 287.535 159.689 288.676 159.69L288.678 156.767C288.312 156.767 287.962 156.622 287.703 156.363L285.636 158.429ZM288.677 159.69H334.023V156.767H288.677V159.69ZM334.024 159.69C335.165 159.689 336.259 159.236 337.065 158.429L334.997 156.363C334.738 156.622 334.388 156.767 334.022 156.767L334.024 159.69ZM337.065 158.429C337.871 157.621 338.323 156.527 338.323 155.386L335.4 155.388C335.4 155.754 335.255 156.104 334.997 156.363L337.065 158.429ZM338.323 155.387V135.368H335.4V155.387H338.323ZM338.323 135.369C338.324 133.105 337.426 130.934 335.826 129.332L333.758 131.397C334.81 132.451 335.401 133.879 335.4 135.367L338.323 135.369ZM335.826 129.332C334.226 127.73 332.056 126.83 329.792 126.828L329.79 129.751C331.279 129.752 332.706 130.344 333.758 131.397L335.826 129.332ZM329.791 126.828L292.909 126.828L292.909 129.751L329.791 129.751L329.791 126.828Z",
    fill: "#191489"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 188.911,
    y: 146.746,
    width: 230.683,
    height: 176.053,
    rx: 18.9752,
    fill: "#D6DCF2",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 203.107,
    y: 146.746,
    width: 230.683,
    height: 176.053,
    rx: 18.9752,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 203,
    y: 146,
    width: 231,
    height: 177
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 203.107,
    y: 146.746,
    width: 230.683,
    height: 176.053,
    rx: 18.9752,
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.894 140.353C466.977 249.086 357.414 312.336 285.488 327.26C213.562 342.184 444.262 369.189 444.262 369.189L485.019 300.254L460.589 158.23L428.646 124.008L397.412 125.429",
    fill: "#D6DCF2"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 203.107,
    y: 146.746,
    width: 230.683,
    height: 176.053,
    rx: 18.9752,
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M357.375 218.68H330.972V192.246C330.974 189.073 328.403 186.5 325.231 186.498H304.568C301.396 186.5 298.826 189.073 298.828 192.246V218.68H272.424C269.252 218.682 266.681 221.255 266.683 224.427V245.114C266.681 248.286 269.252 250.859 272.424 250.861H298.828V277.295C298.826 280.468 301.396 283.041 304.568 283.043H325.231C328.403 283.041 330.974 280.468 330.972 277.295V250.861H357.375C360.548 250.859 363.118 248.286 363.116 245.114V224.427C363.118 221.255 360.548 218.682 357.375 218.68Z",
    fill: "#E43334"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 266,
    y: 186,
    width: 98,
    height: 98
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.376 218.682H330.972V192.248C330.974 189.075 328.404 186.502 325.232 186.5H304.569C301.396 186.502 298.826 189.075 298.828 192.248V218.682H272.424C269.252 218.684 266.682 221.257 266.684 224.429V245.116C266.682 248.288 269.252 250.861 272.424 250.863H298.828V277.297C298.826 280.47 301.396 283.043 304.569 283.045H325.232C328.404 283.043 330.974 280.47 330.972 277.297V250.863H357.376C360.548 250.861 363.119 248.288 363.117 245.116V224.429C363.119 221.257 360.548 218.684 357.376 218.682Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.413 202.003C344.529 228.653 327.492 264.416 275.851 283.045C224.209 301.675 374.342 301.675 374.342 301.675L386.055 252.638L363.116 217.46L330.972 192.248",
    fill: "#C11F27"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.375 218.68H330.972V192.246C330.974 189.073 328.403 186.5 325.231 186.498H304.568C301.396 186.5 298.826 189.073 298.828 192.246V218.68H272.424C269.252 218.682 266.681 221.255 266.683 224.427V245.114C266.681 248.286 269.252 250.859 272.424 250.861H298.828V277.295C298.826 280.468 301.396 283.041 304.568 283.043H325.231C328.403 283.041 330.974 280.468 330.972 277.295V250.861H357.375C360.548 250.859 363.118 248.286 363.116 245.114V224.427C363.118 221.255 360.548 218.682 357.375 218.68V218.68Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M252.198 182.555L243.811 190.927",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M371.237 282.436C368.364 285.993 364.913 289.041 361.027 291.451",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M454.711 234.721V231.408L456.015 230.893C457.763 230.203 458.912 228.514 458.912 226.634V224.654L439.946 222.742L420.98 224.654V226.634C420.98 228.514 422.128 230.203 423.877 230.893L425.181 231.408V234.721C425.181 234.721 411.179 240.838 411.179 255.62V318.086C411.179 319.296 411.658 320.456 412.514 321.312C413.369 322.168 414.529 322.649 415.739 322.65H464.153C465.363 322.649 466.523 322.168 467.378 321.312C468.233 320.456 468.713 319.295 468.713 318.086V255.62C468.713 240.838 454.711 234.721 454.711 234.721Z",
    fill: "#FDD504"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 411,
    y: 222,
    width: 58,
    height: 101
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.711 234.721V231.408L456.015 230.893C457.763 230.203 458.912 228.514 458.912 226.634V224.654L439.946 222.742L420.98 224.654V226.634C420.98 228.514 422.128 230.203 423.877 230.893L425.181 231.408V234.721C425.181 234.721 411.179 240.838 411.179 255.62V318.086C411.179 319.296 411.658 320.456 412.514 321.312C413.369 322.168 414.529 322.649 415.739 322.65H464.153C465.363 322.649 466.523 322.168 467.378 321.312C468.233 320.456 468.713 319.295 468.713 318.086V255.62C468.713 240.838 454.711 234.721 454.711 234.721Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.981 230.293C423.301 235.722 467.723 222.742 465.938 272.696C464.153 322.65 437.484 325.862 437.484 325.862L474.887 325.173L478.329 255.334L461.808 225.469L442.532 224.32",
    fill: "#FCB006"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.711 234.721V231.408L456.015 230.893C457.763 230.203 458.912 228.514 458.912 226.634V224.654L439.946 222.742L420.98 224.654V226.634C420.98 228.514 422.128 230.203 423.877 230.893L425.181 231.408V234.721C425.181 234.721 411.179 240.838 411.179 255.62V318.086C411.179 319.296 411.658 320.456 412.514 321.312C413.369 322.168 414.529 322.649 415.739 322.65H464.153C465.363 322.649 466.523 322.168 467.378 321.312C468.233 320.456 468.713 319.295 468.713 318.086V255.62C468.713 240.838 454.711 234.721 454.711 234.721Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 410.925,
    y: 267.088,
    width: 39.2042,
    height: 35.1717,
    fill: "#1AB995",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 430.527,
    y: 273.629,
    width: 18.8384,
    height: 5.09735,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M424.193 202.215H455.697C458.213 202.215 460.253 204.255 460.253 206.771V228.197C460.253 230.765 458.171 232.847 455.602 232.847H424.288C421.719 232.847 419.637 230.765 419.637 228.197V206.771C419.637 204.255 421.677 202.215 424.193 202.215V202.215Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 419,
    y: 202,
    width: 42,
    height: 31
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.194 202.217H455.698C458.214 202.217 460.254 204.256 460.254 206.773V228.199C460.254 230.767 458.172 232.849 455.603 232.849H424.289C421.72 232.849 419.638 230.767 419.638 228.199V206.773C419.638 204.256 421.678 202.217 424.194 202.217V202.217Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.845 202.216C460.891 202.725 460.254 206.63 460.254 214.441C460.254 222.252 468.713 202.216 468.713 202.216L455.335 196.752L443.347 196.982L423.88 198.82",
    fill: "#D6DCF2"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.193 202.215H455.697C458.213 202.215 460.253 204.255 460.253 206.771V228.197C460.253 230.765 458.171 232.847 455.602 232.847H424.288C421.719 232.847 419.637 230.765 419.637 228.197V206.771C419.637 204.255 421.677 202.215 424.193 202.215V202.215Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 423.88,
    y: 207.139,
    width: 2.3467,
    height: 20.7833,
    rx: 1.17334,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 428.844,
    y: 207.139,
    width: 2.3467,
    height: 20.7833,
    rx: 1.17334,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 433.808,
    y: 207.139,
    width: 2.3467,
    height: 20.7833,
    rx: 1.17334,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 438.772,
    y: 207.139,
    width: 2.3467,
    height: 20.7833,
    rx: 1.17334,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 443.737,
    y: 207.139,
    width: 2.3467,
    height: 20.7833,
    rx: 1.17334,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 448.7,
    y: 207.139,
    width: 2.3467,
    height: 20.7833,
    rx: 1.17334,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 453.665,
    y: 207.139,
    width: 2.3467,
    height: 20.7833,
    rx: 1.17334,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M452.428 248.426C453.476 249.733 454.243 251.242 454.682 252.859",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M431.23 307.695C431.033 309.049 431.514 310.413 432.517 311.342",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M480.64 259.022C504.793 268.44 530.807 257.376 530.807 257.376L505.948 123.895C509.159 123.036 483.907 140.091 480.64 259.022Z",
    fill: "#D6DCF2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M544.347 294.598L517.711 274.155L531.884 266.623L557.857 292.155L544.347 294.598Z",
    fill: "#FACCC4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 517,
    y: 266,
    width: 41,
    height: 29
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.347 294.596L517.711 274.153L531.884 266.621L557.857 292.153L544.347 294.596Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532.542 289.142C542.73 288.413 544.487 278.41 544.487 278.41L534.017 280.607L529.3 283.84",
    fill: "#ED707B"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.347 294.598L517.711 274.155L531.884 266.623L557.857 292.155L544.347 294.598V294.598Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M529.531 321.846C524.884 316.863 536.22 309.491 538.579 301.838C540.939 294.186 537.062 292.503 537.062 292.503L551.229 285.043L556.879 290.38C557.78 291.213 558.288 292.388 558.279 293.615C558.269 294.842 557.742 296.008 556.828 296.826L529.531 321.846Z",
    fill: "#485065",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M528.91 289.145C528.91 289.145 541.603 283.953 545.88 276.366L514.089 233.148L527.032 171.314L499.122 168.918L486.17 229.133C485.997 229.99 485.931 230.865 485.972 231.739C486.079 233.972 486.991 236.103 488.403 237.89L528.91 289.145Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.91 289.145C528.91 289.145 541.603 283.953 545.88 276.366L514.089 233.148L527.032 171.314L499.122 168.918L486.17 229.133C485.997 229.99 485.931 230.865 485.972 231.739C486.079 233.972 486.991 236.103 488.403 237.89L528.91 289.145Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M525.618 313.431L519.971 281.178L535.142 285.511L537.395 320.267L525.618 313.431Z",
    fill: "#FACCC4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 519,
    y: 281,
    width: 19,
    height: 40
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525.617 313.429L519.97 281.176L535.142 285.509L537.395 320.265L525.617 313.429Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M519.97 305.227C529.591 306.282 536.052 299.543 536.052 299.543L524.462 299.669L520.316 301.639",
    fill: "#ED707B"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525.618 313.431L519.971 281.178L535.142 285.511L537.395 320.267L525.618 313.431V313.431Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M495.607 324.2C495.607 317.52 509.192 319.298 516.275 315.121C523.358 310.943 521.637 307.209 521.637 307.209L537.395 310.736L537.988 319.706C538.105 321.474 536.662 322.983 534.801 323.038L495.607 324.2Z",
    fill: "#485065",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M502.594 194.66L516.904 300.722C527.906 307.211 537.201 298.636 537.201 298.636L530.151 234.82L532.294 168.918H499.121",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M497.301 170.305C503.656 186.627 520.125 152.154 530.909 211.532C532.595 220.818 541.748 198.746 542.73 184.235C543.068 179.244 532.295 168.916 532.295 168.916L497.301 170.305Z",
    fill: "#1AB995"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M497.301 170.305C503.656 186.627 520.125 152.154 530.909 211.532C532.595 220.818 541.748 198.746 542.73 184.235C543.068 179.244 532.295 168.916 532.295 168.916L497.301 170.305",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M502.594 194.66L516.904 300.722C527.906 307.211 537.201 298.636 537.201 298.636L530.151 234.82L532.294 168.918H499.121",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M475.785 143.832C475.785 143.832 489.739 117.131 495.817 117.043L499.423 115.364C500.051 115.201 501.148 119.529 501.122 120.178L500.401 130.789C500.397 130.877 500.381 130.965 500.354 131.049L494.719 148.375C494.565 148.849 494.077 149.128 493.591 149.021L476.431 145.231C476.136 145.166 475.888 144.966 475.762 144.692C475.635 144.417 475.644 144.099 475.785 143.832Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 475,
    y: 115,
    width: 27,
    height: 35
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.784 143.83C475.784 143.83 489.738 117.129 495.816 117.041L499.422 115.362C500.05 115.199 501.147 119.527 501.121 120.176L500.4 130.787C500.396 130.875 500.38 130.963 500.353 131.047L494.718 148.373C494.564 148.847 494.076 149.126 493.59 149.019L476.43 145.229C476.135 145.164 475.887 144.964 475.761 144.69C475.634 144.415 475.643 144.097 475.784 143.83Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.2 134.041C486.777 132.289 485.137 150.126 480.64 150.91C476.143 151.695 483.95 157.22 483.95 157.22L491.859 147.778",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.2 134.041C486.777 132.289 485.137 150.126 480.64 150.91C476.143 151.695 483.95 157.22 483.95 157.22L491.859 147.778",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.785 143.832C475.785 143.832 489.739 117.131 495.817 117.043L499.423 115.364C500.051 115.201 501.148 119.529 501.122 120.178L500.401 130.789C500.397 130.877 500.381 130.965 500.354 131.049L494.719 148.375C494.565 148.849 494.077 149.128 493.591 149.021L476.431 145.231C476.136 145.166 475.888 144.966 475.762 144.692C475.635 144.417 475.644 144.099 475.785 143.832Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M495.779 170.703C519.357 179.209 533.972 168.358 533.972 168.358C533.972 168.358 524.415 129.537 532.96 118.356C532.96 118.356 522.224 110.563 504.133 113.958C501.85 114.387 499.157 114.667 497.811 116.563C493.132 123.153 492.897 142.018 497.377 144.941C497.377 144.941 499.257 157.901 495.779 170.703Z",
    fill: "#FDD504"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 494,
    y: 113,
    width: 40,
    height: 61
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M495.778 170.701C519.356 179.207 533.971 168.356 533.971 168.356C533.971 168.356 524.414 129.535 532.959 118.354C532.959 118.354 522.223 110.561 504.132 113.956C501.849 114.385 499.156 114.666 497.81 116.561C493.131 123.151 492.896 142.016 497.376 144.939C497.376 144.939 499.256 157.899 495.778 170.701Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1502_32914)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 514.831,
    cy: 112.148,
    rx: 12.4982,
    ry: 4.18018,
    transform: "rotate(-12.9062 514.831 112.148)",
    fill: "#FACCC4",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.801 131.797L522.102 134.543C522.102 134.543 526.025 156.494 507.29 150.78L506.138 160.738C506.138 160.738 529.636 173.148 507.29 172.829C484.944 172.51 524.961 184.799 525.528 185.131C526.094 185.464 557.117 175.381 557.117 175.381L549.947 149.407L530.988 133.1",
    fill: "url(#paint1_linear_1502_32914)"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M495.779 170.703C519.357 179.209 533.972 168.358 533.972 168.358C533.972 168.358 524.415 129.537 532.96 118.356C532.96 118.356 522.224 110.563 504.133 113.958C501.85 114.387 499.157 114.667 497.811 116.563C493.132 123.153 492.897 142.018 497.377 144.941C497.377 144.941 499.257 157.901 495.779 170.703Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M507.482 97.9043C510.065 102.52 505.925 115.801 505.925 115.801L519.879 113.954L517.793 97.9043H507.482Z",
    fill: "#FACCC4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 505,
    y: 97,
    width: 15,
    height: 19
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.481 97.9062C510.064 102.522 505.924 115.803 505.924 115.803L519.879 113.956L517.793 97.9062H507.481Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.211 117.806C506.22 113.237 510.057 110.586 512.694 102.582C515.964 92.6573 505.061 99.0584 505.061 99.0584C505.061 99.0584 503.969 99.0622 503.486 100.053C503.004 101.043 499.259 111.079 499.259 111.079",
    fill: "#ED707B"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.482 97.9043C510.065 102.52 505.925 115.801 505.925 115.801L519.879 113.954L517.793 97.9043H507.482Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 535.514,
    cy: 68.6577,
    rx: 18.9535,
    ry: 22.8667,
    transform: "rotate(-71.7042 535.514 68.6577)",
    fill: "#485065",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 514.002,
    cy: 89.657,
    rx: 11.5143,
    ry: 13.9749,
    transform: "rotate(-71.7074 514.002 89.657)",
    fill: "#485065",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M507.408 82.0117C491.144 100.279 504.588 109.705 512.694 102.58L517.963 92.6393L507.408 82.0117Z",
    fill: "#FACCC4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 499,
    y: 82,
    width: 19,
    height: 23
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.408 82.0137C491.145 100.281 504.589 109.707 512.695 102.582L517.964 92.6412L507.408 82.0137Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1502_32914)"
  }, _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.27,
    cx: 499.2,
    cy: 95.8078,
    rx: 1.80778,
    ry: 2.37156,
    transform: "rotate(-76.8231 499.2 95.8078)",
    fill: "#ED707B"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.27,
    cx: 510.106,
    cy: 98.3547,
    rx: 1.80778,
    ry: 2.37156,
    transform: "rotate(-76.8231 510.106 98.3547)",
    fill: "#ED707B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M509.216 92.4923C509.429 92.5586 509.608 92.7071 509.712 92.905C509.816 93.1029 509.837 93.3341 509.771 93.5477L509.348 94.9105C509.21 95.3552 508.737 95.6038 508.292 95.4656C507.848 95.3275 507.599 94.855 507.737 94.4103L508.161 93.0474C508.299 92.6027 508.771 92.3542 509.216 92.4923L509.216 92.4923Z",
    fill: "#190000"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M509.775 90.5136C511.269 91.5039 510.685 92.23 509.71 91.6719C508.735 91.1139 508.798 89.8666 509.775 90.5136Z",
    fill: "#190000"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M505.743 95.0429C505.637 95.6037 505.2 95.2902 504.608 95.1778C504.017 95.0653 503.495 95.1965 503.601 94.6358C503.74 94.0723 504.295 93.7157 504.865 93.8241C505.435 93.9324 505.821 94.4678 505.743 95.0429Z",
    fill: "#ED707B"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M501.791 97.3686C501.689 101.552 505.835 100.675 506.433 98.1888C506.461 98.0597 506.407 97.9263 506.295 97.8548C505.827 97.5472 504.433 96.8126 502.079 97.0597C501.92 97.0767 501.797 97.2084 501.791 97.3686Z",
    fill: "#C1525F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 501,
    y: 97,
    width: 6,
    height: 4
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.791 97.3667C501.689 101.55 505.835 100.673 506.433 98.1868C506.461 98.0577 506.407 97.9243 506.295 97.8529C505.827 97.5452 504.433 96.8107 502.079 97.0577C501.92 97.0748 501.797 97.2065 501.791 97.3667Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1502_32914)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 504.196,
    cy: 100.2,
    rx: 2.09526,
    ry: 1.87219,
    transform: "rotate(-7.2651 504.196 100.2)",
    fill: "#993443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.633 96.8704C502.584 97.138 502.541 97.5061 502.598 97.5854C502.951 98.0738 505.066 98.2872 505.395 98.1085C505.486 98.0587 505.66 97.1987 505.66 97.1987L502.977 96.7852",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.633 96.8704C502.584 97.138 502.541 97.5061 502.598 97.5854C502.951 98.0738 505.066 98.2872 505.395 98.1085C505.486 98.0587 505.66 97.1987 505.66 97.1987L502.977 96.7852",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.408 82.0117C491.144 100.279 504.588 109.705 512.694 102.58L517.963 92.6393L507.408 82.0117Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M516.382 97.4567L521.162 92.0594L512.748 80.3787L508.344 80.112C507.136 80.0857 506.06 80.8726 505.72 82.0318",
    fill: "#485065"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M505.72 82.0312C504.299 86.2549 504.126 93.3843 516.382 97.4561L505.72 82.0312Z",
    fill: "#485065"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M505.72 82.0312C504.299 86.2549 504.126 93.3843 516.382 97.4561",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M512.601 95.925C525.056 92.7415 521.138 103.977 511.563 102.207L512.601 95.925Z",
    fill: "#FACCC4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M512.601 95.925C525.056 92.7415 521.138 103.977 511.563 102.207",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 517.089,
    cy: 102.538,
    rx: 2.25582,
    ry: 2.25844,
    fill: "#F9C1BB",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M536.745 122.36L533.492 117.139C533.492 117.139 524.475 113.806 520.949 113.014C520.949 113.014 513.417 117.57 507.726 118.203C486.12 180.985 528.511 254.423 516.801 269.195C516.801 269.195 553.773 269.221 570.636 251.959C533.971 184.776 536.745 122.36 536.745 122.36Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 501,
    y: 113,
    width: 70,
    height: 157
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.745 122.36L533.492 117.139C533.492 117.139 524.475 113.806 520.949 113.014C520.949 113.014 513.417 117.57 507.726 118.203C486.12 180.985 528.511 254.423 516.801 269.195C516.801 269.195 553.773 269.221 570.636 251.959C533.971 184.776 536.745 122.36 536.745 122.36Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M507.546 165.155C504.142 169.93 543.531 177.316 546.809 190.899C550.086 204.481 545.88 175.203 545.88 175.203L533.971 163.072",
    fill: "#D6DCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.039 137.598C522.103 134.545 530.339 154.348 515.408 152.322C500.72 150.329 514.062 159.425 514.062 159.425L532.487 161.489L533.35 149.409",
    fill: "#D6DCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.476 232.055C558.597 260.362 527.811 274.215 527.811 274.215L588.096 269.199",
    fill: "#D6DCF2"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.745 122.36L533.492 117.139C533.492 117.139 524.475 113.806 520.949 113.014C520.949 113.014 513.417 117.57 507.726 118.203C486.12 180.985 528.511 254.423 516.801 269.195C516.801 269.195 553.773 269.221 570.636 251.959C533.971 184.776 536.745 122.36 536.745 122.36Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M495.817 117.043C495.817 117.043 501.843 113.145 505.049 113.145C505.049 113.145 504.775 116.41 507.726 118.204C507.726 118.204 483.106 199.385 486.36 188.045C490.444 173.812 483.536 146.636 490.444 127.213",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M495.817 117.043C495.817 117.043 501.843 113.145 505.049 113.145C505.049 113.145 504.775 116.41 507.726 118.204C507.726 118.204 483.106 199.385 486.36 188.045C490.444 173.812 483.536 146.636 490.444 127.213",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M506.123 115.174L502.728 119.229L500.72 133.654L508.362 136.082L517.922 121.646L518.205 116.348L512.584 116.462L509.63 115.904L507.228 115.698",
    fill: "#FDD504"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M506.123 115.174L502.728 119.229L500.72 133.654L508.362 136.082L517.922 121.646L518.205 116.348L512.584 116.462L509.63 115.904L507.228 115.698",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M508.698 118.728L500.68 134.611L499.548 146.286L502.871 145.32L509.761 133.437L511.437 118.211L508.698 118.728Z",
    fill: "#1A80FD",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M507.979 115.469V118.756C508.117 119.589 509.249 120.277 510.042 120.392L510.683 120.485C511.468 120.599 512.358 120.243 513.038 119.545L515.502 117.014L511.581 116.042L507.979 115.469Z",
    fill: "#1A80FD",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M506.184 111.651C506.184 111.651 506.95 109.141 507.634 109.25C507.634 109.25 506.027 113.137 509.763 114.798L505.986 120.597C505.986 120.597 503.751 114.649 506.184 111.651Z",
    fill: "#FDD504",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M521.126 113.627C521.126 113.627 520.186 110.115 519.502 110.006C519.502 110.006 514.437 113.475 509.763 114.798L513.07 121.599C513.07 121.599 521.24 117.03 521.126 113.627Z",
    fill: "#FDD504",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M506.427 110.955C506.427 110.955 501.244 147.265 501.785 150.912L499.846 149.077L497.594 128.814L500.973 125.852L497.144 123.628L503.028 113.098C503.028 113.098 503.401 111.975 506.427 110.955Z",
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M520.514 111.547L499.846 149.077L517.875 133.393L515.763 128.134L520.654 126.343L522.082 115.335C522.082 115.335 522.817 112.902 520.514 111.547Z",
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M493.484 149.407L491.859 147.78L501.953 137.675C502.405 137.221 504.03 138.848 503.578 139.301L493.484 149.407Z",
    fill: "#FDD504"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 491,
    y: 137,
    width: 13,
    height: 13
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.484 149.407L491.859 147.78L501.953 137.675C502.405 137.221 504.03 138.848 503.578 139.301L493.484 149.407Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M491.666 149.052L491.415 148.8L501.125 139.078L501.377 139.33L491.666 149.052Z",
    fill: "#EEF7FE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M492.119 149.505L491.867 149.253L501.578 139.531L501.829 139.783L492.119 149.505Z",
    fill: "#EEF7FE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M492.554 149.941L492.302 149.688L502.013 139.967L502.265 140.219L492.554 149.941Z",
    fill: "#EEF7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.312 141.105L500.139 138.929L503.34 135.725L505.513 137.9L502.312 141.105Z",
    fill: "#7A24EA",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.1 140.893L500.121 138.912L499.401 139.633L501.38 141.614L502.1 140.893Z",
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.484 149.407L491.859 147.78L501.953 137.675C502.405 137.221 504.03 138.848 503.578 139.301L493.484 149.407Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M488.423 152.846C488.365 152.788 488.406 152.64 488.53 152.466L491.859 147.779L493.484 149.406L488.803 152.739C488.629 152.863 488.481 152.905 488.423 152.846Z",
    fill: "url(#paint2_radial_1502_32914)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 488,
    y: 147,
    width: 6,
    height: 6
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.423 152.846C488.364 152.788 488.406 152.64 488.529 152.466L491.859 147.779L493.484 149.406L488.803 152.739C488.629 152.863 488.481 152.905 488.423 152.846Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.203 150.346L490.921 148.062L492.144 146.838L494.425 149.122L493.203 150.346Z",
    fill: "url(#paint3_radial_1502_32914)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 487.507,
    cy: 153.556,
    rx: 3.08844,
    ry: 1.00739,
    transform: "rotate(-45.0411 487.507 153.556)",
    fill: "#485065",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M510.944 151.852L500.645 149.045L497.376 144.94C496.356 143.657 494.65 143.137 493.088 143.632L485.96 145.89L495.336 155.571L513.527 161.489L510.944 151.852Z",
    fill: "#FACCC4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 485,
    y: 143,
    width: 29,
    height: 19
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M510.945 151.85L500.645 149.043L497.377 144.938C496.357 143.655 494.651 143.135 493.089 143.63L485.961 145.888L495.337 155.57L513.527 161.487L510.945 151.85Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.137 149.408C500.645 149.045 505.014 161.576 496.815 158.076C490.929 155.563 507.161 162.524 507.161 162.524L507.292 150.781",
    fill: "#ED707B"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M510.944 151.852L500.645 149.045L497.376 144.94C496.356 143.657 494.65 143.137 493.088 143.632L485.96 145.89L495.336 155.571L513.527 161.489L510.944 151.852Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M447.489 132.371L474.463 158.265C474.83 158.618 475.316 158.82 475.825 158.832C479.447 158.918 494.349 158.845 498.887 158.821C499.106 158.82 499.302 158.686 499.383 158.483C499.464 158.28 499.414 158.048 499.257 157.897C494.826 153.615 476.224 135.644 472.581 132.188C472.179 131.806 471.645 131.593 471.09 131.594H447.801C447.617 131.594 447.451 131.706 447.382 131.877C447.313 132.048 447.356 132.244 447.489 132.371Z",
    fill: "#7A24EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 447,
    y: 131,
    width: 53,
    height: 28
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.489 132.37L474.464 158.263C474.83 158.616 475.316 158.818 475.825 158.83C479.448 158.916 494.349 158.843 498.888 158.819C499.106 158.818 499.302 158.684 499.383 158.481C499.465 158.278 499.415 158.046 499.257 157.895C494.826 153.613 476.224 135.642 472.582 132.186C472.179 131.804 471.645 131.591 471.09 131.592H447.801C447.617 131.592 447.451 131.704 447.383 131.875C447.314 132.046 447.356 132.242 447.489 132.37Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.643 153.891C478.883 154.447 475.753 158.843 483.829 158.338C491.906 157.832 472.068 162.33 472.068 162.33L468.061 155.444",
    fill: "#6B1AD3"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.489 132.371L474.463 158.265C474.83 158.618 475.316 158.82 475.825 158.832C479.447 158.918 494.349 158.845 498.887 158.821C499.106 158.82 499.302 158.686 499.383 158.483C499.464 158.28 499.414 158.048 499.257 157.897C494.826 153.615 476.224 135.644 472.581 132.188C472.179 131.806 471.645 131.593 471.09 131.594H447.801C447.617 131.594 447.451 131.706 447.382 131.877C447.313 132.048 447.356 132.244 447.489 132.371V132.371Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M466.095 133.102H453.259C453.132 133.102 453.01 133.053 452.917 132.966L451.205 131.364C451.055 131.223 451.006 131.005 451.081 130.814C451.157 130.622 451.342 130.496 451.547 130.496H464.383C464.51 130.496 464.632 130.544 464.725 130.631L466.437 132.234C466.587 132.375 466.636 132.593 466.56 132.784C466.485 132.975 466.3 133.101 466.095 133.102Z",
    fill: "#F9C1BB",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M462.417 147.125C462.417 147.125 461.334 148.997 464.378 151.442C464.378 151.442 464.626 153.108 466.644 153.923C466.644 153.923 467.033 155.199 468.06 155.447C469.087 155.695 468.449 155.447 468.449 155.447C472.839 155.518 474.574 155.908 474.822 154.774C474.822 154.774 475.813 153.888 474.822 152.895C474.822 152.895 473.901 151.229 472.06 151.371C472.06 151.371 472.863 149.754 464.426 148.631L462.417 147.125Z",
    fill: "#FACCC4",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M525.304 131.694L526.592 154.536L505.367 150.331C505.367 150.331 504.573 161.537 507.547 165.152L537.974 172.684C543.232 174.296 545.175 171.31 546.296 167.935C546.916 166.031 546.977 163.989 546.47 162.052C546.47 162.052 542.313 125.974 537.135 119.873C535.991 118.525 534.74 117.598 533.493 117.139",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 505,
    y: 117,
    width: 42,
    height: 57
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525.304 131.69L526.592 154.532L505.367 150.327C505.367 150.327 504.573 161.533 507.547 165.148L537.974 172.68C543.232 174.292 545.175 171.306 546.296 167.931C546.916 166.027 546.977 163.985 546.47 162.048C546.47 162.048 542.313 125.97 537.135 119.869C535.991 118.521 534.74 117.594 533.493 117.135",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.542 148.562C509.084 152.544 513.527 169.485 513.527 169.485L510.542 148.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.542 148.562C509.084 152.544 513.527 169.485 513.527 169.485",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M525.304 131.694L526.592 154.536L505.367 150.331C505.367 150.331 504.573 161.537 507.547 165.152L537.974 172.684C543.232 174.296 545.175 171.31 546.296 167.935C546.916 166.031 546.977 163.989 546.47 162.052C546.47 162.052 542.313 125.974 537.135 119.873C535.991 118.525 534.74 117.598 533.493 117.139",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M515.15 171.984C514.903 172.17 514.673 172.378 514.463 172.605C510.788 176.542 511.948 186.514 512.714 193.113L512.879 194.537L514.01 194.426L513.846 192.998C513.149 186.997 511.981 176.955 515.298 173.401C516.196 172.435 517.36 172.011 518.854 172.1L518.902 170.953C517.43 170.865 516.172 171.212 515.15 171.984Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 511,
    y: 170,
    width: 8,
    height: 25
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.15 171.984C514.903 172.17 514.673 172.378 514.463 172.605C510.788 176.542 511.948 186.514 512.714 193.113L512.879 194.537L514.01 194.426L513.846 192.998C513.149 186.997 511.981 176.955 515.298 173.401C516.196 172.435 517.36 172.011 518.854 172.1L518.902 170.953C517.43 170.865 516.172 171.212 515.15 171.984Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.303 193.428C512.715 193.116 512.802 192.868 512.375 192.136C511.948 191.405 511.252 193.481 511.305 193.559C511.358 193.636 513.174 195.121 513.191 194.995C513.207 194.868 514.737 194.117 514.737 194.117",
    fill: "url(#paint4_linear_1502_32914)"
  }))), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.15 171.984C514.903 172.17 514.673 172.378 514.463 172.605C510.788 176.542 511.948 186.514 512.714 193.113L512.879 194.537L514.01 194.426L513.846 192.998C513.149 186.997 511.981 176.955 515.298 173.401C516.196 172.435 517.36 172.011 518.854 172.1L518.902 170.953C517.43 170.865 516.172 171.212 515.15 171.984Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M521.113 169.928L518.871 170.09C518.606 170.11 518.36 170.236 518.189 170.44C518.018 170.643 517.936 170.907 517.962 171.171L518.035 172.01C518.083 172.566 518.565 172.982 519.122 172.947L521.364 172.784C521.629 172.764 521.875 172.638 522.046 172.435C522.217 172.232 522.299 171.968 522.274 171.703L522.2 170.864C522.153 170.309 521.67 169.893 521.113 169.928Z",
    fill: "#485065",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M525.274 204.981L525.485 206.014C526.34 210.234 527.225 214.597 530.463 216.338C532.71 217.546 535.185 217.666 539.26 215.949L538.388 214.389C534.829 215.884 533.012 215.719 531.265 214.78C528.773 213.44 528.009 209.674 527.201 205.688L526.989 204.648L525.274 204.981Z",
    fill: "#1A80FD",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M509.27 175.31C509.573 175.247 509.882 175.21 510.192 175.201C515.589 175.017 522.405 182.419 526.915 187.317L527.89 188.374L527.065 189.152L526.087 188.093C521.985 183.639 515.121 176.184 510.25 176.35C508.928 176.393 507.843 176.989 506.932 178.171L506.029 177.456C506.927 176.292 508.015 175.573 509.27 175.31Z",
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M503.806 178.451L505.398 176.872C505.588 176.686 505.845 176.583 506.111 176.588C506.378 176.593 506.631 176.704 506.815 176.896L507.404 177.501C507.795 177.898 507.795 178.535 507.403 178.931L505.811 180.511C505.621 180.697 505.364 180.799 505.098 180.795C504.832 180.79 504.578 180.679 504.395 180.486L503.806 179.881C503.414 179.485 503.414 178.848 503.806 178.451Z",
    fill: "#485065",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M512.396 193.872C513.595 203.867 519.036 206.095 521.319 206.589C525.223 207.412 529.21 205.614 531.178 202.143C532.272 200.189 534.15 194.903 527.981 188.043L526.693 189.22C530.489 193.441 531.567 197.827 529.649 201.253C528.055 204.066 524.823 205.525 521.658 204.86C517.624 203.987 514.882 199.915 514.134 193.689L512.396 193.872Z",
    fill: "#1A80FD",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M541.669 218.654L515.999 220.948L512.364 199.385H536.522L541.669 218.654Z",
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M539.026 201.789H510.672L509.448 195.125L536.194 194.539L539.026 201.789Z",
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M522.918 150.011L511.699 150.953C511.395 150.973 511.096 150.871 510.868 150.669C510.64 150.467 510.502 150.183 510.484 149.879L509.968 143.232C509.908 142.599 510.369 142.036 511.001 141.969L522.22 141.028C522.524 141.008 522.823 141.11 523.051 141.312C523.279 141.513 523.417 141.798 523.435 142.102L523.951 148.749C524.011 149.382 523.55 149.945 522.918 150.011Z",
    fill: "#1A80FD"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.918 150.011L511.699 150.953C511.395 150.973 511.096 150.871 510.868 150.669C510.64 150.467 510.502 150.183 510.484 149.879L509.968 143.232C509.908 142.599 510.369 142.036 511.001 141.969L522.22 141.028C522.524 141.008 522.823 141.11 523.051 141.312C523.279 141.513 523.417 141.798 523.435 142.102L523.951 148.749C524.011 149.382 523.55 149.945 522.918 150.011Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 513.687,
    cy: 146.546,
    rx: 1.94184,
    ry: 2.01852,
    fill: "#1D62FC"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M522.15 144.421L516.861 144.865L516.823 144.374L522.112 143.93L522.15 144.421Z",
    fill: "#1D62FC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M522.281 146.097L516.992 146.541L516.954 146.049L522.243 145.605L522.281 146.097Z",
    fill: "#1D62FC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M520.986 147.894L517.121 148.218L517.083 147.727L520.948 147.402L520.986 147.894Z",
    fill: "#1D62FC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M520.458 140.72L518.216 140.908L518.133 139.852C518.108 139.408 517.906 138.993 517.574 138.699C517.241 138.405 516.804 138.256 516.361 138.285C515.439 138.382 514.766 139.204 514.854 140.127L514.936 141.183L512.693 141.371L512.831 143.149L520.596 142.498L520.458 140.72Z",
    fill: "#FDD504",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M500.257 93.3105C501.229 95.012 504.608 95.179 504.608 95.179C504.608 95.179 506.855 96.8806 511.107 96.2688C512.23 96.4496 510.395 102.763 512.143 103.034C501.285 113.165 497.121 102.126 500.257 93.3105Z",
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 503.656,
    cy: 171.438,
    rx: 1.94893,
    ry: 1.95119,
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M541.246 61.6172C542.724 62.0244 543.805 63.2909 543.976 64.8147",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M512.457 84.4941C512.297 85.3851 512.599 86.2964 513.261 86.9146",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M516.287 310.754L520.295 313.432C516.279 314.442 512.15 314.933 508.009 314.895",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M526.729 154.258C528.647 154.837 530.399 155.864 531.841 157.254",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M544.471 239.725C541.921 243.003 538.306 245.287 534.25 246.182",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M495.932 232.758C496.342 234.061 497.402 235.057 498.729 235.384",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M326.919 417.848C294.661 397.783 248.692 362.96 240.691 366.146C223.341 373.054 314.037 435.315 314.037 435.315L326.919 417.848Z",
    fill: "#FACCC4",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M376.147 446.275C361.476 418.97 303.635 367.509 297.873 368.002C292.11 368.494 296.631 375.093 303.177 381.758C309.723 388.423 348.365 448.209 348.365 448.209L376.147 446.275Z",
    fill: "#FACCC4",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M264.117 391.382C244.183 380.547 206.775 372.155 202.689 373.061C198.604 373.967 194.182 377.074 194.182 377.074C194.182 377.074 300.638 428.97 326.059 449.389C365.646 481.188 387.876 449.492 387.876 449.492L264.117 391.382Z",
    fill: "#FACCC4",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M428.204 369.028C388.896 361.754 395.619 440.001 374.5 437.957C353.382 435.913 266.806 366.993 261.853 366.832C256.9 366.671 258.367 377.133 261.388 381.307C264.408 385.48 387.553 508.566 397.429 523.829C407.305 539.092 447.786 513.691 447.786 513.691C447.786 513.691 462.835 469.431 426.207 431.112C407.15 411.176 428.204 369.028 428.204 369.028Z",
    fill: "#FACCC4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 258,
    y: 366,
    width: 193,
    height: 163
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.204 369.026C388.896 361.752 395.619 439.999 374.5 437.955C353.382 435.911 266.806 366.991 261.853 366.83C256.9 366.669 258.367 377.131 261.388 381.305C264.408 385.478 387.553 508.564 397.429 523.827C407.305 539.09 447.786 513.689 447.786 513.689C447.786 513.689 462.835 469.429 426.207 431.11C407.15 411.174 428.204 369.026 428.204 369.026Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.12 396.023C411.417 395.513 410.856 375.426 421.415 370.691C431.974 365.956 431.303 392.084 431.303 392.084L427.12 396.023Z",
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.468 366.557C270.733 376.286 280.558 391.378 277.338 402.141C274.119 412.904 254.512 391.891 254.512 391.891",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.468 366.557C270.733 376.286 280.558 391.378 277.338 402.141C274.119 412.904 254.512 391.891 254.512 391.891",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.964 472.427C375.11 503.652 457.846 509.362 457.846 509.362L343.921 555.936L319.26 471.701",
    fill: "#ED707B"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.204 369.028C388.896 361.754 395.619 440.001 374.5 437.957C353.382 435.913 266.806 366.993 261.853 366.832C256.9 366.671 258.367 377.133 261.388 381.307C264.408 385.48 387.553 508.566 397.429 523.829C407.305 539.092 447.786 513.691 447.786 513.691C447.786 513.691 462.835 469.431 426.207 431.112C407.15 411.176 428.204 369.028 428.204 369.028Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9453,
    y: 322.514,
    width: 566.492,
    height: 55.0802,
    fill: "#1A80FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 322,
    width: 568,
    height: 56
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9453,
    y: 322.514,
    width: 566.492,
    height: 55.0802,
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3716 377.594C104.75 322.514 563.573 400.244 623.458 357.924C683.343 315.603 640.191 420.545 640.191 420.545L238.485 463.549L35.1782 418.271",
    fill: "#1D62FC"
  }))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9453,
    y: 322.514,
    width: 566.492,
    height: 55.0802,
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5337,
    y: 333.424,
    width: 423.165,
    height: 33.2605,
    fill: "#1A80FD",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 531.537,
    y: 333.424,
    width: 57.7229,
    height: 33.2605,
    fill: "#1A80FD",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M370.291 512.898L457.845 509.367L493.291 566.643L393.784 567.559L370.291 512.898Z",
    fill: "#1B80FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1502_32914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 370,
    y: 509,
    width: 124,
    height: 59
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.291 512.896L457.845 509.365L493.291 566.641L393.784 567.557L370.291 512.896Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1502_32914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.17 501.029C380.649 503.944 389.276 509.953 395.152 518.008C401.666 526.937 404.811 537.977 404.131 549.016C403.8 554.378 402.854 560.751 398.547 564.419C397.31 565.473 397.468 567.597 398.547 568.681C399.772 569.912 401.55 569.737 402.79 568.681C407.449 564.713 409.021 558.431 409.779 552.597C410.572 546.363 410.261 540.038 408.86 533.913C406.186 522.202 399.577 511.762 390.136 504.336C384.955 500.255 379.066 497.164 372.765 495.217C369.064 494.079 367.482 499.895 371.17 501.029Z",
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.406 501.827C441.16 516.821 446.821 535.532 451.003 553.861C452.221 559.198 453.319 564.561 454.406 569.926C454.729 571.522 456.61 572.441 458.096 572.031C459.748 571.575 460.516 569.924 460.191 568.324C456.275 548.996 452.158 529.31 442.878 511.736C440.232 506.746 437.143 502.003 433.648 497.565C432.645 496.285 430.456 496.51 429.406 497.565C428.148 498.829 428.4 500.544 429.406 501.827Z",
    fill: "white",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.291 512.898L457.845 509.367L493.291 566.643L393.784 567.559L370.291 512.898V512.898Z",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7086 346.639L81.186 351.341",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M430.142 453.668C428.472 460.179 424.663 465.94 419.326 470.028",
    stroke: "#191489",
    strokeWidth: 2.92267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1502_32914",
    x1: 489.376,
    y1: 116.763,
    x2: 491.281,
    y2: 174.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1011,
    stopColor: "#FFA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8855,
    stopColor: "#FF6E3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1502_32914",
    x1: 512.367,
    y1: 193.487,
    x2: 513.381,
    y2: 191.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1011,
    stopColor: "#FEC456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F54345"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1502_32914",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(488.713 152.628) rotate(45.0335) scale(4.19581 4.19581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0035,
    stopColor: "#FFEF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0661,
    stopColor: "#FCD29B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F95C51"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1502_32914",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(491.978 149.572) rotate(45.0335) scale(5.32374 5.32373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0035,
    stopColor: "#FFEF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0383,
    stopColor: "#FCF89B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9976,
    stopColor: "#F9C951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1502_32914",
    x1: 510.274,
    y1: 189.783,
    x2: 510.079,
    y2: 194.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1023,
    stopColor: "#DCDCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8855,
    stopColor: "#F5F6FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandinImage);
export default __webpack_public_path__ + "static/media/landinImage.02b33b29d0ca3990bddf09ff1ad26867.svg";
export { ForwardRef as ReactComponent };